/* eslint-disable */
import React from 'react';
import { TweenMax, TimelineMax, Quart, Expo, Back } from 'gsap/all';
import cls from 'classnames';
import PropTypes from 'prop-types';
import css from './TooltipAR.scss';

const classes = {
	root: css.tooltipAr,
	box: css.tooltipArBox,
	boxButton: css.tooltipArBoxButton,
	boxButtonIcon: css.tooltipArBoxButtonIcon,
	boxButtonIconX: css.tooltipArBoxButtonIconX,
	boxButtonIconY: css.tooltipArBoxButtonIconY,
	isOpened: css.isOpened,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	opened: PropTypes.bool,
};

const defaultProps = {
	className: '',
	classes,
	opened: false,
};

export const TooltipAR = React.forwardRef(({
	className,
	classes,
	opened,
	...props
}, ref) => {
	const rootRef = React.useRef();
	const [isOpened, setIsOpened] = React.useState(opened);

	const toggle = () => {
		setIsOpened(!isOpened);
	};

	const onClickOpen = () => {
		toggle();
	};

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
	}));

	return (
		<div
			{...props}
			ref={rootRef}
			onClick={onClickOpen}
			className={cls(classes.root, className, {
				[classes.isOpened]: isOpened,
			})}>
			<i className={cls('fa', 'fa-question-circle')}></i>
			Descubra se o seu celular é compatível.

			<div className={cls(classes.box)}>
				A realidade aumentada funciona
				em aparelhos com sensores
				de movimento e câmera;
				Android a partir do 9.0 e iPhone do 7;
				e Google Chrome em sistemas
				Android e Safari em iOS.
				<button className={cls(classes.boxButton)}>
					<i className={classes.boxButtonIcon} aria-hidden>
						<span className={classes.boxButtonIconX}/>
						<span className={classes.boxButtonIconY}/>
					</i>
				</button>
			</div>
		</div>
	);
});

TooltipAR.displayName = 'TooltipAR';
TooltipAR.propTypes = propTypes;
TooltipAR.defaultProps = defaultProps;
export default TooltipAR;
